module.exports = __webpack_public_path__ + "img/mbanner-image-md.32f50920.webp";